export default "__VITE_ASSET__XkqQTKeb__"